import React, { useState, useEffect } from "react";
import Nav from "react-bootstrap/Nav";
import Modal from "react-bootstrap/Modal";
import useTheme from "./useTheme";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";

const ManageComments = (props) => {
  const [showComments, setShowComments] = useState(false);

  const [showDelete, setShowDelete] = useState(false);

  const [showRes, setShowRes] = useState(false);

  const [theme, switchTheme] = useTheme();

  const [isLoading, setIsLoading] = useState(false);

  const [isLoadingRes, setIsLoadingRes] = useState(false);

  const [comments, setComments] = useState([]);

  const [pk, setPk] = useState(0);

  const [res, setRes] = useState("");

  useEffect(() => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append("getManageComments", 1);
    formData.append("vitrinCode", props.vitrinCode);
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: formData,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        setComments(data.data);
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e);
      });
  }, [res]);

  const manage = (type, pkComment) => {
    setIsLoadingRes(true);
    setShowRes(true);
    const formData = new FormData();
    formData.append("manageComment", 1);
    if (type === "delete") {
      formData.append("pk", pk);
    }
    if (type === "confirm") {
      formData.append("pk", pkComment);
    }
    formData.append("type", type);
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: formData,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        setIsLoadingRes(false);
        console.log(data);
        setRes(data.data);
      })
      .catch((e) => {
        console.log(e);
        setIsLoadingRes(false);
        setRes("اشکال در برقراری ارتباط با سرور");
      });
  };

  return (
    <div>
      <Nav.Link
        onClick={() => {
          setShowComments(true);
        }}
        href="#"
        className={theme === "light" ? "text-dark" : "text-light"}
      >
        {" نظرات "}
        {comments.length > 0 ? (
          <span className="badge badge-danger">{comments.length}</span>
        ) : null}
      </Nav.Link>
      <Modal
        show={showComments}
        onHide={() => {
          setShowComments(false);
        }}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
      >
        <Modal.Header
          className={
            theme === "light"
              ? "bg-light text-dark justify-content-center"
              : "bg-dark text-light justify-content-center"
          }
        ></Modal.Header>
        <Modal.Body
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          {isLoading ? (
            <div className="row justify-content-center m-5 p-5">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : comments.length > 0 ? (
            comments.map((item, index) => (
              <div
                key={index}
                className={
                  theme === "light"
                    ? "card bg-light mb-3"
                    : "card bg-light text-dark mb-3"
                }
              >
                <div className="card-header">
                  {item.kalaName + " (" + item.barcodeKar + ")"}
                </div>
                <div className="card-body">
                  <h5 className="card-title">{item.title}</h5>
                  <p className="card-text">{item.matn}</p>
                </div>
                <div className="card-footer inlined">
                  <small className="text-muted">{item.tarikh}</small>
                  <div>
                    <button
                      className="btn btn-sm btn-success mr-2"
                      onClick={() => {
                        manage("confirm", item.pkComments);
                      }}
                    >
                      <FontAwesomeIcon icon={faCheck} />
                    </button>
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => {
                        setPk(item.pkComments);
                        setShowDelete(true);
                      }}
                    >
                      {" "}
                      <FontAwesomeIcon icon={faTimes} />{" "}
                    </button>
                  </div>
                  <small className="text-muted">{item.name}</small>
                </div>
              </div>
            ))
          ) : (
            <p>نظری یافت نشد</p>
          )}
        </Modal.Body>

        <Modal.Footer
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <button
            className="btn btn-dark"
            onClick={() => {
              setShowComments(false);
            }}
          >
            بستن
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showDelete}
        onHide={() => {
          setShowDelete(false);
        }}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
      >
        <Modal.Header
          className={
            theme === "light"
              ? "bg-light text-dark justify-content-center"
              : "bg-dark text-light justify-content-center"
          }
        ></Modal.Header>
        <Modal.Body
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <p>آیا از حذف پیام مطمئن هستید؟</p>
        </Modal.Body>

        <Modal.Footer
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <button
            className="btn btn-danger"
            onClick={() => {
              setShowDelete(false);
            }}
          >
            خیر
          </button>
          <button
            className="btn btn-success"
            onClick={() => {
              manage("delete");
            }}
          >
            بله
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showRes}
        onHide={() => {
          setShowDelete(false);
          setShowRes(false);
        }}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
      >
        <Modal.Header
          className={
            theme === "light"
              ? "bg-light text-dark justify-content-center"
              : "bg-dark text-light justify-content-center"
          }
        ></Modal.Header>
        <Modal.Body
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          {isLoadingRes ? (
            <div className="row justify-content-center m-5 p-5">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : (
            <div>{res}</div>
          )}
        </Modal.Body>

        <Modal.Footer
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <button
            className="btn btn-dark"
            onClick={() => {
              setShowDelete(false);
              setShowRes(false);
            }}
          >
            بستن
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ManageComments;
